import { makeStyles } from '@material-ui/core/styles';

export const useSuccessStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    padding: theme.spacing(1.5),
    backgroundColor: theme.palette.success.lighter,
    border: '1px solid',
    borderColor: theme.palette.success.light,
    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(1.5, 3),
    },
  },
  content: {
    display: 'flex',
    fontWeight: 500,
    color: `${theme.palette.success.main} !important`,
  },
  icon: {
    marginRight: theme.spacing(2),
    height: '18px !important',
    width: '18px !important',
  },
}));

export const useErrorStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    padding: theme.spacing(1.5),
    backgroundColor: theme.palette.error.lighter,
    border: '1px solid',
    borderColor: theme.palette.error.light,
    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(1.5, 3),
    },
  },
  content: {
    display: 'flex',
    fontWeight: 500,
    color: `${theme.palette.error.main} !important`,
  },
  icon: {
    marginRight: theme.spacing(2),
  },
}));

export const useWarningStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    padding: theme.spacing(1.5),
    backgroundColor: theme.palette.warning.lighter,
    border: '1px solid',
    borderColor: theme.palette.warning.light,
    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(1.5, 3),
    },
  },
  content: {
    display: 'flex',
    fontWeight: 500,
    color: `${theme.palette.warning.main} !important`,
  },
  icon: {
    marginRight: theme.spacing(2),
    height: '18px !important',
    width: '18px !important',
  },
}));

export const useInfoStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    padding: theme.spacing(1.5),
    backgroundColor: '#E3F5FB',
    border: '1px solid',
    borderColor: '#ACDDF6',
    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(2),
    },
  },
  content: {
    display: 'flex',
    fontWeight: 500,
    color: `#1B3642 !important`,
  },
  icon: {
    marginRight: theme.spacing(2),
    height: '18px !important',
    width: '18px !important',
  },
  subText: {
    display: 'flex',
    fontWeight: 400,
    color: `#1B3642`,
  },
}));
